import { configureStore } from "@reduxjs/toolkit";
import ipDataReducer from "../Redux-slices/ipDataSlice.js";
import loginReducer from "../Redux-slices/loginSlice.js";
import contactUsReducer from "../Redux-slices/contactSlice.js";
import SaleDataReducer from "../Redux-slices/saveSaleInfo.js"
import partnerReducer from "../Redux-slices/partnerInfoSlice.js" 

const store = configureStore({
  reducer: {
    login: loginReducer,
    ipData: ipDataReducer,
    contact: contactUsReducer,
    saleData:SaleDataReducer,
    partner :partnerReducer
  },
});

export default store;
